var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 7.5004C-0.000244141 10.5101 1.89938 13.0759 4.56493 14.065L5.17366 7.50037L4.56493 0.935791C1.89938 1.92487 -0.000244141 4.49064 -0.000244141 7.5004Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 7.49997C14.0001 3.634 10.866 0.499969 7.00007 0.499969C6.14383 0.499969 5.3236 0.653997 4.56525 0.935364V14.0646C5.3236 14.346 6.14383 14.5 7.00007 14.5C10.866 14.5 14.0001 11.3659 14.0001 7.49997Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56532 9.93512C5.91001 9.93512 7.00009 8.84504 7.00009 7.50035C7.00009 6.15567 5.91001 5.06558 4.56532 5.06558C3.22064 5.06558 2.13055 6.15567 2.13055 7.50035C2.13055 8.84504 3.22064 9.93512 4.56532 9.93512Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19537 6.28238V7.80412C3.19537 8.5605 3.80853 9.17368 4.56494 9.17368C5.32135 9.17368 5.93451 8.56053 5.93451 7.80412V6.28238H3.19537Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5653 8.26052C4.31357 8.26052 4.10876 8.05571 4.10876 7.80399V7.19531H5.0218V7.80401C5.0218 8.05571 4.81699 8.26052 4.5653 8.26052Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.5989e4386665a011221aa4102df37ab7.svg";
export { ForwardRef as ReactComponent };